// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-popover .role-select{width:173px}.user-role-popover.tooltip.popover .popover-inner{padding:12px;max-width:29rem}.user-role-popover.tooltip.popover .popover-inner .actions{display:grid;grid-column-gap:1rem;-webkit-column-gap:1rem;-moz-column-gap:1rem;column-gap:1rem;grid-template-columns:37.6% 1fr}", ""]);
// Exports
module.exports = exports;
